import { render, staticRenderFns } from "./MyContractsNoContracts.vue?vue&type=template&id=3dafd081"
import script from "./MyContractsNoContracts.vue?vue&type=script&lang=js"
export * from "./MyContractsNoContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports